import { concat, from, timer } from "rxjs";
import { mapTo, switchMapTo, take } from "rxjs/operators";
import { click$ } from "../../../events/eventsBrowser";
import { selectActiveTutorialConfig } from "../../../selectors/selectTutorial";
import { actionShowMeConsumeBuildingInfoInInBuildMenu, actionShowMeSelectBuildingInfoInBuildMenu, } from "../../show-me/actionShowMe";
import { selectBuildingCategoryType } from "../../show-me/selectors/selectBuildingCategoryType";
import { actionTutorialSelect } from "../actionTutorial";
export var pathTutorialConstructClickBuyButton = function (action, state$, deps) {
    var state = state$.value;
    var tutorialConfig = selectActiveTutorialConfig(state);
    var buildingId = tutorialConfig.buildingId;
    var tabId = parseInt(selectBuildingCategoryType(state, buildingId), 10);
    var selectBuildingInfo$ = from([
        actionShowMeSelectBuildingInfoInBuildMenu(tabId, buildingId),
    ]);
    return concat(selectBuildingInfo$, 
    // It is only there because action$ is not present in paths to filter and listen to click
    timer(250).pipe(mapTo(actionTutorialSelect(tutorialConfig.nextStep))), timer(1).pipe(switchMapTo(click$.pipe(take(1), mapTo(actionShowMeConsumeBuildingInfoInInBuildMenu())))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/path/pathTutorialConstructClickBuyButton.ts
// module id = 2486
// module chunks = 3